import { z } from "zod";

/**
 * Location coordinates schema
 */
export const locationCoordinatesSchema = z.object({
  /**
   * Latitude coordinate
   */
  latitude: z.number().min(-90).max(90),

  /**
   * Longitude coordinate
   */
  longitude: z.number().min(-180).max(180),
});

export type Coordinates = z.infer<typeof locationCoordinatesSchema>;

/**
 * Location schema
 */
export const locationSchema = z.object({
  /**
   * Coordinates (latitude and longitude)
   */
  coordinates: locationCoordinatesSchema,

  /**
   * Address string
   */
  address: z.string().max(500),
});

export type Location = z.infer<typeof locationSchema>;



/**
 * Location schema for user data
 */
export const userLocationSchema = z.object({}).catchall(z.any());

export const addressTypeSchema = z.object({
  code: z.enum(["HOME", "WORK", "OTHER"]),
  name: z.string().optional()
});

export type AddressType = z.infer<typeof addressTypeSchema>;

export const recipientSchema = z.object({
  code: z.enum(["ME", "OTHER"]),
  name: z.string(),
  contact: z.string().optional()
});

export type Recipient = z.infer<typeof recipientSchema>;

export const googlePlusCodeSchema = z.object({
  globalCode: z.string(),
  compoundCode: z.string()
});

export type GooglePlusCode = z.infer<typeof googlePlusCodeSchema>;

export const addressSchema = z.object({
  id: z.string().optional(),
  userId: z.string().optional(),
  coordinates: locationCoordinatesSchema,
  country: z.string(),
  state: z.string(),
  city: z.string(),
  postalCode: z.string(),
  area: z.string().optional(),
  type: addressTypeSchema,
  houseNumber: z.string(),
  society: z.string(),
  recipient: recipientSchema.optional(),
  floor: z.string().optional(),
  landmark: z.string().optional(),
  formattedAddress: z.string().optional(),
  googlePlaceId: z.string().optional(),
  googlePlusCode: googlePlusCodeSchema.optional(),
  createdAt: z.number().optional(),
  updatedAt: z.number().optional(),
  isDeleted: z.boolean().optional(),
  isDefault: z.boolean().optional()
});

export type Address = z.infer<typeof addressSchema>;